A method of applying to a position on a draft position profile.
